module.exports = __webpack_public_path__ + "static/media/work-time@2x.ef582f48.png";